import { jsxs as r, jsx as c } from "react/jsx-runtime";
import e from "./style.module.less.js";
import m from "./tick.svg.js";
const k = (l) => {
  const { label: s, onChange: n, checked: o, className: t, disabled: a } = l, i = () => {
    a || n(!o);
  };
  return /* @__PURE__ */ r(
    "label",
    {
      className: `${e.checkboxInputLabel} ${a ? e.disabled : ""} ${t ?? ""}`,
      onClick: i,
      children: [
        o ? /* @__PURE__ */ c("div", { className: e.checkboxChecked, children: /* @__PURE__ */ c(m, { className: e.tickIcon }) }) : /* @__PURE__ */ c("div", { className: e.checkbox }),
        typeof s == "string" ? /* @__PURE__ */ c(
          "span",
          {
            dangerouslySetInnerHTML: {
              __html: s
            }
          }
        ) : s
      ]
    }
  );
};
export {
  k as CheckboxInput
};
